<template>
  <div>
    <dt>{{ label }}</dt>
    <dd v-if="professor">{{ professor.nome }}</dd>
  </div>
</template>

<script>
import ProfessorService from "../../../../domain/corpore/ProfessorService";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "view-c-protocolo-todos-professores",
  props: {
    label: String,
    value: String
  },
  asyncComputed: {
    professor() {
      const professorService = new ProfessorService(this.$http);
      return professorService
        .getProfessores()
        .then(result =>
          result.find(professor => this.value == professor.codprof)
        )
        .catch(err => {
          SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/View/TodosProfessores.vue